<template>
    <div class="container mt-3">
        <div class="new-create">
            <div class="row">
                <div class="col-md-12 new-background mb-5">

                    <h1 class="mb-4 mt-4 new-heading" v-if="!team">Update Team member</h1>
                    <h1 class="mb-4 mt-4 new-heading" v-if="team">Add Team member</h1>

                    <form>
                        <div class="form-group mb-3">
                            <label><b>Select Department</b></label>
                            <td scope="row">
                                <select v-model="teamAdd.department_id" class="form-control">
                                    <option
                                            v-for="(department, index) in DepartmentsDetails" v-bind:key="index"
                                            name="department_id"
                                            :value="department.id">{{ department.department}}
                                    </option>
                                </select>
                            </td>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label><b>First Name</b></label>
                                    <input type="text"
                                           v-model="teamAdd.first_name"
                                           required name="first_name"
                                           class="form-control">
                                    <small v-if="errors.has('first_name')" class="text-danger">
                                        {{ errors.first('first_name') }}
                                    </small>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label><b>Last Name</b></label>
                                    <input type="text"
                                           v-model="teamAdd.last_name"
                                           required name="last_name"
                                           class="form-control">
                                    <small v-if="errors.has('last_name')" class="text-danger">
                                        {{ errors.first('last_name') }}
                                    </small>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label><b>Job Title</b></label>
                                    <input type="text"
                                           v-model="teamAdd.job_title"
                                           required name="job_title"
                                           class="form-control">
                                    <small v-if="errors.has('job_title')" class="text-danger">
                                        {{ errors.first('job_title') }}
                                    </small>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label><b>Profile Picture</b></label>
                                    <ProfilePictureUploadField class="profile-picture"
                                                               name="profile_picture"
                                                               @imageFile="teamAdd.profile_picture = $event" />
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label><b>Email</b></label>
                                    <input type="text"
                                           v-model="teamAdd.email"
                                           required name="email"
                                           class="form-control">
                                    <small v-if="errors.has('email')" class="text-danger">
                                        {{ errors.first('email') }}
                                    </small>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label><b>Facebook</b></label>
                                    <input type="text"
                                           v-model="teamAdd.facebook"
                                           required name="facebook"
                                           class="form-control">
                                    <small v-if="errors.has('facebook')" class="text-danger">
                                        {{ errors.first('facebook') }}
                                    </small>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label><b>Linkedin</b></label>
                                    <input type="text"
                                           v-model="teamAdd.linked_in"
                                           required name="linked_in"
                                           class="form-control">
                                    <small v-if="errors.has('linked_in')" class="text-danger">
                                        {{ errors.first('linked_in') }}
                                    </small>
                                </div>
                            </div>
                        </div>

                        <div class="mb-5 mt-3">
                            <button type="button"
                                    class="btn btn-primary"
                                    v-if="!team"
                                    @click="update_team()">UPDATE
                            </button>
                            <button type="button" class="btn btn-primary" v-if="team" @click="add_team()">ADD
                            </button>
                            <router-link :to="{name: 'website-managements-teams'}" class="btn btn-secondary">Back</router-link>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ProfilePictureUploadField from "./ProfilePictureUploadField";
import Editor from "@tinymce/tinymce-vue";
import axios from "axios";
import _ from "lodash";

export default {
  name: "CreateDepartments",
  components: {
    Editor,
    ProfilePictureUploadField
  },
  data() {
    return {
      teamAdd: {},
      team: true,
      DepartmentsDetails: {}
    };
  },
  methods: {
    get_Departments() {
      axios({
        url:
          "admin/management/department/all" +
          "?access_token=" +
          localStorage.getItem("access_token"),
        method: "get",
        body: {},
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(
          result => {
            this.DepartmentsDetails = result.data.department;
          },
          error => {
            console.log(error.response);
          }
        )
        .catch(e => {
          console.log(e);
        });
    },
    add_team: async function() {
      this.teamAdd.access_token = localStorage.getItem("access_token");

      let team = new FormData();
      team.append("access_token", this.teamAdd.access_token);
      team.append("department_id", this.teamAdd.department_id);
      team.append("job_title", this.teamAdd.job_title);
      team.append("first_name", this.teamAdd.first_name);
      team.append("last_name", this.teamAdd.last_name);
      team.append("email", this.teamAdd.email);
      team.append("facebook", this.teamAdd.facebook);
      team.append("linked_in", this.teamAdd.linked_in);
      team.append("profile_picture", this.teamAdd.profile_picture);

      try {
        await axios.post("admin/management/team/add", team);
      } catch (e) {
        if (e.response.status === 401) {
          return alert(`${e.response.data.error}`);
        }
        let errors = _.get(e.response.data, "error");
        alert(`${errors[Object.keys(errors)[0]]}`);
        console.log(e.response);
      }
    },
    getsingleTeam() {
      axios({
        url:
          "/admin/management/team/" +
          this.$route.params.team_member_id +
          "?access_token=" +
          localStorage.getItem("access_token"),
        method: "get",
        body: {},
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(
          result => {
            this.teamAdd = result.data.team;
          },
          error => {
            console.log(error.response);
          }
        )
        .catch(e => {
          console.log(e);
        });
    },
    update_team: function() {
      this.teamAdd.access_token = localStorage.getItem("access_token");
      axios({
        method: "PUT",
        url:
          "/admin/management/team/update/" + this.$route.params.team_member_id,
        data: this.teamAdd,
        headers: {
          "content-type": "application/json"
        }
      }).then(
        result => {
          if (result.data.status === true) {
            this.$swal("Team Member Updated Successfully", "", "success");
          }
        },
        error => {
          this.$swal("Error", "There was an error. Please try again", "error");
          error;
        }
      );
    }
  },
  mounted: function() {
    if (this.$route.params.team_member_id > 0) {
      this.team = false;
      this.getsingleTeam();
    } else {
      this.teamAdd = {};
      this.team = true;
    }
    this.get_Departments();
  }
};
</script>

<style lang="scss">
.new-create {
  padding-right: 20px;
  padding-left: 20px;
  .new-heading {
    font-size: 35px;
  }
  .form-control:focus {
    box-shadow: 0 0 0 0.2rem rgb(255, 255, 255);
  }
  .new-background {
    border-radius: 4px;
    box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.08);
    border: solid 0.5px #e8ebf2;
    background-color: #ffffff;
  }
}
</style>
